import React, { useState } from "react";
import Sidebar from "../components/Sidebar";

const API: React.FC = () => {
  const [apiKey, setApiKey] = useState("sk_live_1234567890abcdef");
  const [showKey, setShowKey] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(apiKey);
    alert("คัดลอก API Key แล้ว");
  };

  const regenerateKey = () => {
    if (confirm("คุณแน่ใจหรือไม่ที่จะสร้าง API Key ใหม่? API Key เดิมจะไม่สามารถใช้งานได้")) {
      setApiKey("sk_live_" + Math.random().toString(36).substring(2, 15));
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">จัดการ API</h1>
          <p className="text-gray-600 mb-6">จัดการ API Keys และการเข้าถึง API</p>

          <div className="bg-white rounded-lg shadow p-6 border border-gray-200 mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">API Key</h2>
            <div className="flex gap-4">
              <input
                type={showKey ? "text" : "password"}
                value={apiKey}
                readOnly
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg bg-gray-50"
              />
              <button
                onClick={() => setShowKey(!showKey)}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
              >
                {showKey ? "ซ่อน" : "แสดง"}
              </button>
              <button
                onClick={copyToClipboard}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                คัดลอก
              </button>
              <button
                onClick={regenerateKey}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                สร้างใหม่
              </button>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6 border border-gray-200 mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">ข้อมูลการใช้งาน API</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <p className="text-sm text-gray-600">คำขอรวม</p>
                <p className="text-2xl font-bold text-gray-900">1,234</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">คำขอสำเร็จ</p>
                <p className="text-2xl font-bold text-green-600">1,198</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">คำขอล้มเหลว</p>
                <p className="text-2xl font-bold text-red-600">36</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">เอกสาร API</h2>
            <div className="space-y-4">
              <div className="border border-gray-200 rounded-lg p-4">
                <h3 className="font-medium text-gray-900 mb-2">POST /api/payments/create</h3>
                <p className="text-sm text-gray-600 mb-2">สร้างคำสั่งชำระเงินใหม่</p>
                <code className="text-xs bg-gray-100 px-2 py-1 rounded">
                  {"{ \"amount\": 1000, \"currency\": \"THB\", \"method\": \"promptpay\" }"}
                </code>
              </div>
              <div className="border border-gray-200 rounded-lg p-4">
                <h3 className="font-medium text-gray-900 mb-2">GET /api/payments/:id</h3>
                <p className="text-sm text-gray-600 mb-2">ดูข้อมูลคำสั่งชำระเงิน</p>
                <code className="text-xs bg-gray-100 px-2 py-1 rounded">
                  GET /api/payments/PAY-001
                </code>
              </div>
              <div className="border border-gray-200 rounded-lg p-4">
                <h3 className="font-medium text-gray-900 mb-2">POST /api/orders/create</h3>
                <p className="text-sm text-gray-600 mb-2">สร้างคำสั่งซื้อใหม่</p>
                <code className="text-xs bg-gray-100 px-2 py-1 rounded">
                  {"{ \"customer_id\": \"CUST-001\", \"items\": [...] }"}
                </code>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default API;
